import { Document, Page } from '@react-pdf/renderer'

import { TimelineOrder } from '../../types/feedTypes'
import { getActivityTimeline } from '../../utils/feedUtils'
import { styles } from '../styles/styles'
import type { ReportTemplateIProps } from '../types/types'
import { getIncidentDescription } from '../utils/utils'
import { Attachments } from '../views/Attachments'
import { Details } from '../views/Details'
import { EditableFields } from '../views/EditableFields'
import { Footer } from '../views/Footer'
import { Header } from '../views/Header'
import { Resolution } from '../views/Resolution'
import { Workflow } from '../views/Workflow'

export const ReportTemplate = ({
  attachments,
  branding,
  exportDetails,
  incident,
  isSalesEnvironment,
  me,
  workflowReportData,
  workflowUserNameMap,
}: ReportTemplateIProps) => {
  const actions = incident?.actions || []
  const events = incident?.events || []
  const audioMessages =
    incident?.audioMessages?.edges?.map((a) => a?.node) || []
  const notes = incident?.notes?.edges?.map((a) => a?.node) || []
  const timeZone = incident?.facility?.timeZone

  const timeline = getActivityTimeline(
    actions,
    events,
    audioMessages,
    notes,
    me,
    isSalesEnvironment,
    TimelineOrder.Asc
  )

  const device = incident?.devices[0]

  const incidentDescription = getIncidentDescription(
    incident?.type,
    incident?.description,
    incident?.floor?.name,
    device?.name,
    incident?.name
  )

  return (
    <Document style={styles.document}>
      <Page style={styles.page}>
        <Header branding={branding} incident={incident} />
        <Resolution incident={incident} />
        <Details
          createdAt={incident?.createdAt}
          incidentDescription={incidentDescription}
          timeZone={timeZone}
          timeline={timeline}
        />
        <Attachments attachments={attachments} notes={notes} />
        <Workflow
          timeZone={timeZone}
          workflowReportData={workflowReportData}
          workflowUserNameMap={workflowUserNameMap}
        />
        <EditableFields />
        <Footer exportDetails={exportDetails} />
      </Page>
    </Document>
  )
}
